module.exports = __webpack_public_path__ + "img/RKD-front.5e082d53.jpg";